import { createGlobalStyle } from 'styled-components';
const RootStyle = createGlobalStyle `
   html,
  body {
    height: 100%;
    padding: 0;
    margin: 0;
    font-family: ${({ theme }) => theme.typography.bodyFontFamily};
    font-size: ${({ theme }) => theme.typography.bodyFontSize};
    font-weight: ${({ theme }) => theme.typography.bodyFontWeight};
    line-height: ${({ theme }) => theme.typography.bodyLineHeight};
    color: ${({ theme }) => theme.typography.bodyColor};
    background-color: ${({ theme }) => theme.typography.bodyBg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: hsl(0 0% 33% / 1) transparent;
  }

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .zoom-controls {
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: rgba(255, 255, 255, 0.9); /* Light background for visibility */
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  }

  .zoom-btn {
    width: 40px;
    height: 40px;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background-color: #ffffff;
    color: #333;
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 4px;
  }

  .zoom-btn:hover {
    background-color: #e0e0e0;
  }

  .ol-zoom {
    bottom: 20px;
    right: 20px;
    left: auto;
    position: absolute;
    top: auto;
    border-radius: 15px;
    padding: 2px;
    background-color: hsla(0, 0%, 0%, 0.07);
    button {
      cursor: pointer;
      background-color: hsla(0, 0%, 100%, 1);
      color: hsla(0, 0%, 33.33%, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: background-color 0.1s linear;
      border: none;
      border-radius: calc(15px - 2px) !important;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
      padding: calc(calc(5px * 2) - 2px) calc(calc(5px * 3) - 2px);
      min-height: calc(18px + calc(calc(5px * 2) - 2px) * 2);
      font-size: 18px;
      line-height: 18px;
      box-sizing: border-box;
      width: 34px;
      height: auto;
    }
  }
  .ol-attribution {
    display: none;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  @media (min-width: 992px) {
    div,
    main,
    ol,
    pre,
    span,
    ul {
      scrollbar-width: thin;
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    :root {
      scroll-behavior: smooth;
    }
  }

  h6,
  .h6,
  h5,
  .h5,
  h4,
  .h4,
  h3,
  .h3,
  h2,
  .h2,
  h1,
  .h1 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    color: ${({ theme }) => theme.typography.headingColor};
  }

  abbr[title] {
    text-decoration: underline dotted;
    cursor: help;
    -webkit-text-decoration: underline dotted;
    text-decoration-skip-ink: none;
  }

  address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
  }

  ol,
  ul {
    padding-left: 2rem;
  }

  ol,
  ul,
  dl {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  ol ol,
  ul ul,
  ol ul,
  ul ol {
    margin-bottom: 0;
  }

  dt {
    font-weight: 700;
  }

  dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
  }

  blockquote {
    margin: 0 0 1rem;
  }

  b,
  strong {
    font-weight: bolder;
  }

  small,
  .small {
    font-size: 0.875em;
  }

  mark,
  .mark {
    padding: 0.1875em;
  }

  sub,
  sup {
    position: relative;
    font-size: 0.75em;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  a:not([href]):not([class]),
  a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none;
  }

  pre,
  code,
  kbd,
  samp {
    font-family: ${({ theme }) => theme.typography.fontMonospace};
    font-size: 1em;
  }

  pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: 0.875em;
  }

  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
  }

  code {
    font-size: 0.875em;
    color: ${({ theme }) => theme.typography.linkColor};
    word-wrap: break-word;
  }

  a > code {
    color: inherit;
  }

  kbd {
    padding: 0.1875rem 0.375rem;
    font-size: 0.875em;
    border-radius: ${({ theme }) => theme.borders.radius.sm};
  }

  kbd kbd {
    padding: 0;
    font-size: 1em;
  }

  figure {
    margin: 0 0 1rem;
  }

  img,
  svg {
    vertical-align: middle;
  }

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  caption {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    text-align: left;
  }

  th {
    text-align: inherit;
  }

  thead,
  tbody,
  tfoot,
  tr,
  td,
  th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
  }

  button {
    border-radius: 0;
  }

  button:focus:not(:focus-visible) {
    outline: 0;
  }

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  button,
  select {
    text-transform: none;
  }

  [role='button'] {
    cursor: pointer;
  }

  select {
    word-wrap: normal;
  }

  [list]:not([type='date']):not([type='datetime-local']):not([type='month']):not([type='week']):not(
      [type='time']
    )::-webkit-calendar-picker-indicator {
    display: none !important;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  button:not(:disabled),
  [type='button']:not(:disabled),
  [type='reset']:not(:disabled),
  [type='submit']:not(:disabled) {
    cursor: pointer;
  }

  ::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }

  textarea {
    resize: vertical;
  }

  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }

  legend {
    float: left;
    width: 100%;
    padding: 0;
    line-height: inherit;
  }

  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem;
    }
  }

  legend + * {
    clear: left;
  }

  ::-webkit-datetime-edit-fields-wrapper,
  ::-webkit-datetime-edit-text,
  ::-webkit-datetime-edit-minute,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-year-field {
    padding: 0;
  }

  ::-webkit-inner-spin-button {
    height: auto;
  }

  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }

  ::file-selector-button {
    font: inherit;
    -webkit-appearance: button;
  }

  output {
    display: inline-block;
  }

  iframe {
    border: 0;
  }

  summary {
    display: list-item;
    cursor: pointer;
  }

  progress {
    vertical-align: baseline;
  }

  [hidden] {
    display: none !important;
  }

  .bc-select {
    text-align: start;
  }
  .bc-dropdown {
    padding-top: 4px;
  }

  .bc-select-dropdown,
  .bc-dropdown-menu {
    --bc-color-bg-elevated: hsla(0, 0%, 100%, 1);

    --bc-border-radius-lg: calc(12px * 4 / 3);
    --bc-box-shadow-secondary: 0 8px 10px -6px hsla(0, 0%, 0%, 0.1), 0 15px 35px -5px hsla(0, 0%, 0%, 0.1),
      0 0 0 1px hsla(0, 0%, 0%, 0.07), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
    --bc-select-option-padding: 8px 10px;
    --bc-border-radius-sm: calc(15px * 2 / 3);
    .bc-select-item-option-active:not(.bc-select-item-option-disabled) {
      --bc-select-option-active-bg: hsla(0, 0%, 0%, 0.07);
    }

    /* margin: calc(5 * 1px) 0;
    padding: calc(calc(5 * 1px) * 2)
      calc(calc(5 * 1px) * 2); */
  }

  .bc-checkbox .bc-checkbox-inner {
    width: 18px;
    height: 18px;
    --bc-border-radius-sm: 6px;
    /* border: none; */
    /* clip-path: path("M9 1c1.01 0 2.02.08 3.06.23l.57.1a5 5 0 0 1 4.05 4.04 20.63 20.63 0 0 1 .09 6.69l-.1.57a5 5 0 0 1-4.04 4.05 20.63 20.63 0 0 1-6.69.09l-.57-.1a5 5 0 0 1-4.05-4.04 20.63 20.63 0 0 1-.09-6.69l.1-.57a5 5 0 0 1 4.04-4.05C6.57 1.11 7.79 1 9 1Zm0 2c-1.1 0-2.19.1-3.28.3a3 3 0 0 0-2.43 2.42l-.09.55a18.55 18.55 0 0 0 .1 6.01 3 3 0 0 0 2.42 2.43l.55.09a18.55 18.55 0 0 0 6.01-.1 3 3 0 0 0 2.43-2.42l.09-.55a18.55 18.55 0 0 0-.1-6.01 3 3 0 0 0-2.42-2.43l-.55-.09C10.83 3.07 9.91 3 9 3Z");
    --bc-color-border: hsla(129, 60%, 50%, 1); */
    --bc-color-border: hsla(129, 60%, 50%, 1);
    --bc-line-width: 2px;
  }

  canvas {
    outline: none;
  }
`;
export default RootStyle;
